<div class="content-wrapper-inner relative">
  <app-disabled-section-widget [service]="'ntc'" (changeState)="serviceDisabled = !$event.service"></app-disabled-section-widget>
  <div *ngIf="serviceDisabled === false" class="page-content">
    <div class="table-topbar">
      <div class="search-holder">
        <h3>SMPP Sessions & Suppliers</h3>
      </div>
      <div class="table-action-holder">
        <app-smpp-session-guide />

        <span class="divider"></span>

        <div class="import me-20 cp" (keyup.enter)="onClickImport()" tabindex="0" (click)="onClickImport()" tooltip="Import sessions and suppliers">
          <a class="bg-neutral-n1"><span class="icon-import fs-4 text-neutral-n9"></span></a>
        </div>
        <div class="create">
          <a (keyup.enter)="onClickCreateSmppConnection()" tabindex="0" (click)="onClickCreateSmppConnection()" class="btn btn-primary py-10 px-15"
            ><span class="icon-add"></span>Create Session</a
          >
        </div>
      </div>
    </div>
    <app-session-supplier-search (onSubmit)="onSubmitFilter($event)"></app-session-supplier-search>
    <div>
      <app-session-table (actions)="sessionAction($event)" (changeBatch)="onChangeBatchSelect($event)"></app-session-table>
      <!-- The table on batch select has an action menu shown … -->
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (keyup.enter)="batchClear()" tabindex="0" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows.length }} Selected</span>
          </div>
        </div>
        <div class="info-right" *ngIf="isSessionBatchActive; else supplierOptions">
          <div class="info-right">
            <div class="text-icon-holder" (keyup.enter)="batchDeleteSessions()" tabindex="0" (click)="batchDeleteSessions()">
              <span class="icon">
                <span class="icon-negative"></span>
              </span>
              <span class="text">Delete</span>
            </div>

            <div class="text-icon-holder" (keyup.enter)="batchEnableDisableSessions()" tabindex="0" (click)="batchEnableDisableSessions()">
              <span class="icon">
                <span class="icon-warning"></span>
              </span>
              <span class="text">Enable/Disable</span>
            </div>
          </div>
        </div>
        <ng-template #supplierOptions>
          <div class="info-right">
            <div class="text-icon-holder" (keyup.enter)="batchDeleteSuppliers()" tabindex="0" (click)="batchDeleteSuppliers()">
              <span class="icon">
                <span class="icon-negative"></span>
              </span>
              <span class="text">Delete</span>
            </div>
            <div class="text-icon-holder" (keyup.enter)="batchMoveSuppliers()" tabindex="0" (click)="batchMoveSuppliers()">
              <span class="icon">
                <span class="icon-connections"></span>
              </span>
              <span class="text">Move</span>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #sessionCreateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create SMPP Session</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-session-create (afterSupplierSave)="afterSessionSupplierSave()"></app-session-create>
  </div>
</ng-template>

<ng-template #sessionUpdateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Update SMPP Session</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-session-update (afterSupplierSave)="afterSessionSupplierSave()"></app-session-update>
  </div>
</ng-template>

<ng-template #supplierCreateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create supplier</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-supplier-create (afterSupplierSave)="afterSessionSupplierSave()"></app-supplier-create>
  </div>
</ng-template>

<ng-template #supplierUpdateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Update supplier</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-supplier-update (afterSupplierSave)="afterSessionSupplierSave()"></app-supplier-update>
  </div>
</ng-template>

<ng-template #importModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Import from excel</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-connections-import (finished)="importFinished()" (closed)="dialogRef.close(true)"></app-connections-import>
  </div>
</ng-template>

<ng-template #reassignSuppliersModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Moving {{ selectedRows.length }} Suppliers</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="search-bar">
      <p class="text-neutral-n6">Select to which SMPP session you would like to move selected suppliers</p>
      <input class="form-control" type="text" placeholder="Search SMPP session ..." [formControl]="searchControl" />
    </div>
    <table class="session-table w-100">
      <thead>
        <tr>
          <th>Session ID</th>
          <th>Login</th>
          <th>Host</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let session of sessionsList"
          class="session-row cp"
          [ngClass]="{ active: session.id === selectedSessionToMoveTo?.id }"
          (click)="selectedSessionToMoveTo = session">
          <td>{{ session.id }}</td>
          <td>{{ session.systemId }}</td>
          <td>
            {{ session.hostIp }}:{{ session.hostPort }}
            <span class="fas fa-circle fs-6" [ngClass]="{ 'text-success-s2': session.online, 'text-error-r2': !session.online }"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark px-15" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-15" (click)="reassignSuppliers()">Move</button>
    </div>
  </div>
</ng-template>
